module.exports = __webpack_public_path__ + "static/media/kavak-provider.3e532881.svg";